import { SessionStorageService } from './../../services/session.service';
import {
  iUser,
  Partizioni,
} from './../../models/user.model';
import { MessageService } from 'src/app/services/message.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Giro } from './../../models/giro.model';
import { NuovoAutoreComponent } from './../nuovo-autore/nuovo-autore.component';
import { description } from 'src/app/models/books.model';
import { ToastrService } from 'ngx-toastr';
import { LocalStorageService } from './../../services/storage.service';
import { BookService } from './../../services/book.service';
import { Wbook, WBookEntity } from './../../models/wbook';
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  AbstractControl,
  AsyncValidatorFn,
  FormControl,
  ValidationErrors,
} from '@angular/forms';
import * as _ from 'lodash';
import * as moment from 'moment';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { MatDialog } from '@angular/material/dialog';
import { COMMA, ENTER, T } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { environment } from 'src/environments/environment';
import { concat, EMPTY, merge, Observable, of, Subscription } from 'rxjs';
import {
  catchError,
  delay,
  map,
  startWith,
  switchMap,
  tap,
} from 'rxjs/operators';
import { MatSelect } from '@angular/material/select';
import { GenericDialogComponent } from '../generic-dialog/generic-dialog.component';
import { Router } from '@angular/router';

export interface simpleResponce {
  success: boolean;
  filename: string;
}

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'book-form',
  templateUrl: './book-form.component.html',
  styleUrls: ['./book-form.component.scss'],
})
export class BookFormComponent
  implements OnInit, OnDestroy
{
  @Input() book: Wbook = new Wbook();
  @Input() oid: number = 0;
  @Input() ristampa: boolean = false;
  @Input() viewOnly: boolean = false;
  @Input() consegnatoMagazzino: boolean = false;

  dataConsegnaMagazzino;
  charTag = true;
  loadingCopertina = false;
  loadingScheda = false;
  loading = true;
  error = false;
  disabilitaModifiche = false;
  immagineCopertina = null;
  images: { file: File; imageType: { code: string; label: string } }[] = [];
  pdffilename = '';
  novita = null;
  collane: Array<description>;
  autoriSelected: Array<description> = [];
  collaboratoriSelected: Array<any> = [];
  generi: Array<description>;
  categorie: Array<description>;
  argomenti: Array<description>;
  lingue: Array<description>;
  rilegature: Array<description>;
  mesiUscita: Array<description> = [];
  loadingAutori = false;
  loadingAdditionalImages = false;
  /** Stato della barra di avanzamento a step mostrata durante l'inserimento di una nuova novità. */
  submitStepIndex = 0;
  submitStepsTotal = 0;
  submitStepLabel = '';
  giri: Giro[];
  defaultCodiciAutori = [];
  autore;
  steps = 0;
  nsteps = 6;
  errors = {
    richiestastampa: false,
  };
  annoEdizione = moment().format('Y');
  meseEdizione;
  aliquotaIva: description;
  tags = [];
  defaultAutori: Array<description>;
  defaultCollaboratori: any[];
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  startImages = true; // uso questa per non andare a toccare il componente princiaple di list images
  erroPatternObj = [];

  tabellaIva = [
    { cod: '101', iva: 74 },
    { cod: '102', iva: 74 },
    { cod: '103', iva: 22 },
    { cod: '104', iva: 22 },
    { cod: '105', iva: 22 },
    { cod: '106', iva: 22 },
    { cod: '107', iva: 22 },
    { cod: '108', iva: 22 },
    { cod: '109', iva: 22 },
    { cod: '110', iva: 22 },
    { cod: '111', iva: 22 },
    { cod: '112', iva: 22 },
    { cod: '113', iva: 22 },
    { cod: '114', iva: 22 },
    { cod: '115', iva: 22 },
    { cod: '116', iva: 22 },
    { cod: '117', iva: 22 },
    { cod: '118', iva: 22 },
    { cod: '140', iva: 22 },
    { cod: '150', iva: 22 },
    { cod: '154', iva: 5 },
    { cod: '180', iva: 74 },
  ];

  @Output() OnClickNovita = new EventEmitter<boolean>();
  @Output() OnBookInserted = new EventEmitter<number>();

  private copertina = new FormData();
  private schedaNovita = new FormData();
  private additionalImages = new FormData();
  isbn: string = null;

  /**@todo spostare in un servizio o scrivere un file json tipo cod: descrizione */
  public mesi = [
    { cod: 1, name: 'gennaio' },
    { cod: 2, name: 'febbraio' },
    { cod: 3, name: 'marzo' },
    { cod: 4, name: 'aprile' },
    { cod: 5, name: 'maggio' },
    { cod: 6, name: 'giugno' },
    { cod: 7, name: 'luglio' },
    { cod: 8, name: 'agosto' },
    { cod: 9, name: 'settembre' },
    { cod: 10, name: 'ottobre' },
    { cod: 11, name: 'novembre' },
    { cod: 12, name: 'dicembre' },
  ];

  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '15rem',
    minHeight: '5rem',
    placeholder: '',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
    toolbarHiddenButtons: [
      [
        'bold',
        'customClasses',
        'insertImage',
        'insertVideo',
        'link',
        'unlink',
        'toggleEditorMode',
        'clearFormatting',
        'subscript',
        'superscript',
        'aepicker',
      ],
    ],
  };
  disabledConfig: AngularEditorConfig = {
    editable: false,
    spellcheck: false,
    height: '15rem',
    minHeight: '5rem',
    placeholder: '',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
    toolbarHiddenButtons: [
      [
        'undo',
        'redo',
        'bold',
        'italic',
        'underline',
        'strikeThrough',
        'subscript',
        'superscript',
        'justifyLeft',
        'justifyCenter',
        'justifyRight',
        'justifyFull',
        'indent',
        'outdent',
        'insertUnorderedList',
        'insertOrderedList',
        'heading',
        'fontName',
      ],
      [
        'fontSize',
        'textColor',
        'backgroundColor',
        'customClasses',
        'link',
        'unlink',
        'insertImage',
        'insertVideo',
        'insertHorizontalRule',
        'removeFormat',
        'toggleEditorMode',
      ],
    ],
  };
  storageData: Giro = null;
  public formTitle = '';
  firstGiro: Giro = null;
  action = null;
  isbnOptions: string[] = [];
  filteredOptions: Observable<string[]>;
  isbnControl = new FormControl('');
  editFull = true;
  modalitaStampaData = null;
  giroSelezionato = null;
  usr: iUser;
  loadingGiro = false;
  subscriptions: Subscription[] = [];
  private stepsInterval: any = null;
  private beforeUnloadHandler = (event: BeforeUnloadEvent) => {
    event.preventDefault();
    event.returnValue = '';
    return 'Sei sicuro di voler lasciare questa pagina?';
  };

  /**
   * L'ISBN non è mai modificabile in fase di modifica di una novità (per qualsiasi
   * profilo, admin compreso): si può impostare solo al primo inserimento.
   * Resta bloccato anche quando i campi sono già disabilitati (disabilitaModifiche).
   */
  get isbnReadonly(): boolean {
    return this.disabilitaModifiche || this.action === 'edit';
  }

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private storage: LocalStorageService,
    private session: SessionStorageService,
    private bookservice: BookService,
    private toast: ToastrService,
    private domSanitizer: DomSanitizer,
    private messageservice: MessageService
  ) {
    this.usr = this.session.get('usr'); 


    if (this.usr.partizioni) {
      this.usr.partizioni.forEach((partizione) => {
        this.isbnOptions.push(partizione.EP_PARTIZIONE);
      });
    }
    this.filteredOptions =
      this.isbnControl.valueChanges.pipe(
        startWith(''),
        map((value) => this._filter(value))
      );

    //aggiungo il validatore al FormControl dell'isbn
    if (!this.ristampa) {
      this.isbnControl.setAsyncValidators(
        this.isbnAsyncValidator()
      );
      this.isbnControl.updateValueAndValidity();
    }
  }

  ngOnInit(): void {

    // messaggio se: vien fatto il refresh, viene chiusa la tab o viene chiuso il browser
    if (!this.viewOnly) {
      window.addEventListener(
        'beforeunload',
        this.beforeUnloadHandler
      );
    }
    this.loading = true;
    if (this.usr.profile === 'editore') {
      this.getCollane();
    }
    this.getCategorie();
    this.getGeneri();
    this.getLingue();
    this.getRilegature();
    this.getArgomenti();
    this.firstGiro = this.storage.get('firstGiro');
    this.storageData = this.storage.get('giro');

    if (this.oid) {
      this.loadBook(this.oid);
      this.action = 'edit';
      this.formTitle = 'Modifica novità';
    } else {
      this.book.nuGiro = Number(this.storageData.numero);
      this.book.annoGiro = Number(this.storageData.anno);
      this.action = 'insert';
      this.formTitle = 'Inserimento novità';
      this.modalitaStampaData = new Date(
        this.storageData.data_scadenza
      );
    }

    if (this.ristampa) {
      /*  if(this.usr.profile === 'admin'){
        this.storageData = this.storage.get('selectedGiro');
      } */
      this.book.nuGiro = Number(this.storageData.numero);
      this.book.annoGiro = Number(this.storageData.anno);
      this.action = 'insert';
      this.formTitle = 'Ristampa';
      this.makeDefaultAuthors();
      this.disabilitaModifiche = true;
      this.getTabellaIva(false);
      this.loadCopertina();
      this.loadSchedaNovita();

      this.isbnControl.setAsyncValidators(
        this.isbnAsyncValidator()
      );
      this.isbnControl.updateValueAndValidity();
    }
    if (this.usr.profile === 'admin') {
      this.book.editore = this.storage.get(
        'selectedEditore'
      );
      this.storage.remove('selectedEditore');
      this.disabilitaModifiche = false;
      this.getPartizioni();
      if (this.book.editore) {
        this.getCollaneAdmin(this.book.editore);
      }
    }
    if (this.book.upload > 0) {
      // esiste la copertina del libro.
      const request = this.bookservice.imageRequest(
        this.book.isbn.toString()
      );
      fetch(request, { cache: 'reload' })
        .then((response) => response.blob())
        .then((blob) => {
          this.immagineCopertina =
            URL.createObjectURL(blob);
        });
    }

    this.loading = false;
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.isbnOptions.filter(
      (option) =>
        option.toLowerCase().indexOf(filterValue) === 0
    );
  }

  makeDefaultAuthors() {
    for (let i = 1; i < 7; i++) {
      if (Number(this.book['cod_autore_' + i]) !== 0) {
        this.defaultCodiciAutori.push(
          Number(this.book['cod_autore_' + i])
        );
      }
    }
    const sub = this.bookservice
      .getAutoriInfo(this.defaultCodiciAutori)
      .subscribe((data: Array<description>) => {
        this.autoriSelected = data;
      });

    this.subscriptions.push(sub);

    if (this.ristampa) {
      const callAutori = this.book.collaboratori.map(
        (el) => el.cod
      );
      const subRistampa = this.bookservice
        .getAutoriInfo(callAutori)
        .subscribe((data: Array<description>) => {
          this.collaboratoriSelected = data.map((el) => ({
            ...el,
            type: 'curatore',
          }));
        });
      this.subscriptions.push(subRistampa);
    }
  }

  /**
   * prendo tutti i giri
   * @param anno
   */
  getGiri(anno = 0) {
    this.loadingGiro = true;
    const sub = this.bookservice
      .getGiriByYear(anno)
      .subscribe((giri: Array<Giro>) => {
        this.giri = giri;
        const data: Array<description> = [];
        this.giri = this.giri.map((item: Giro) => ({
          ...item,
          cod: `${item.anno}.${item.numero}`,
        })); /* .filter(
          (el) =>
            moment(el.data_distribuzione).isAfter(moment())
        ) */
        this.setGiroDefault();
      });

    this.subscriptions.push(sub);
  }

  /**
   * Mi setto il giro corretto del libro
   */
  setGiroDefault() {
    this.giroSelezionato = this.giri.filter((giro) => {
      const nuGiro =
        this.book.nuGiro.toString().length < 2
          ? `0${this.book.nuGiro}`
          : this.book.nuGiro.toString();

      return (
        nuGiro === giro.numero &&
        this.book.annoGiro.toString() === giro.anno
      );
    })[0];

    this.loadingGiro = false;
  }

  changeGiro(event: MatSelect) {
    const giro = event.value.split('.');
    this.book.nuGiro = parseInt(giro[1], 10);
    this.book.annoGiro = parseInt(giro[0], 10);
  }

  loadBook(oid) {
    const sub = this.bookservice
      .getEntityNovita(oid)
      .subscribe((data: WBookEntity) => {
        const b = new Wbook();
        b.setValues(data);
        this.setCollaboratoriInput(data.collaboratori[0]);
        this.book = b;

        if (this.usr.profile === 'admin') {
          this.getCollaneAdmin(this.book.editore);
        }
        this.makeDefaultAuthors();
        const t = this.book.tags.split(',');
        t.forEach((item) => {
          if (item.replace(' ', '').length > 0)
            this.tags.push(item);
        });
        this.stepsInterval = setInterval(() => {
          if (this.steps === this.nsteps) {
            this.getTabellaIva(false);
            clearInterval(this.stepsInterval);
            this.stepsInterval = null;
          }
        }, 100);
        if (this.usr.profile === 'editore') {
          const giro = Number(
            this.firstGiro.anno +
              (Number(this.firstGiro.numero) - 1)
          );
          const giroLibro = Number(
            this.book.annoGiro + Number(this.book.nuGiro)
          );

          if (giroLibro === giro || giroLibro > giro) {
            this.disabilitaModifiche = false;
          } else {
            this.disabilitaModifiche = true;
          }
        }

        //** controllo se si tratta di una ristampa */
        if (
          this.book.idRistampa &&
          this.book.idRistampa.length > 1
          && this.usr.profile !== 'admin'
        ) {
          this.disabilitaModifiche = true;
        }
        if (this.book.upload > 0) {
          // esiste la copertina del libro.
          this.loadCopertina();
        }
        this.loadSchedaNovita();

        // quando ho caricato il libro mi carico anche i giri
        this.getGiri();

        this.dataConsegnaMagazzino = moment(
          this.book.datapubblicazione
        )
          .subtract(14, 'days')
          .format('DD-MM-YYYY');
      });
    this.subscriptions.push(sub);
  }

  setCollaboratoriInput(collaboratori) {
    const collab = {
      CUR: 'curatore',
      ILL: 'illustratore',
      TRA: 'traduttore',
      PRE: 'prefazione',
    };

    for (let i = 1; i <= 5; i++) {
      const collabObj = {
        cod: collaboratori[`cod_ruolo${i}`],
        descrizione: collaboratori[`name${i}`],
        type: collab[collaboratori[`ruolo${i}`]],
      };

      this.collaboratoriSelected.push(collabObj);
    }

    this.collaboratoriSelected =
      this.collaboratoriSelected.filter(
        (collab) => collab.descrizione
      );
  }

  /**
   * loadSchedaNovita
   */
  loadSchedaNovita() {
    this.loadingScheda = true;
    const request = this.bookservice.schedaNovitaRequest(
      this.book.isbn.toString()
    );
    fetch(request, { cache: 'reload' }).then((response) => {
      if (response.status != 404) {
        response.blob().then((blob) => {
          this.novita =
            this.domSanitizer.bypassSecurityTrustResourceUrl(
              URL.createObjectURL(blob)
            );
          this.setPdf(blob, 'novita', true);
          this.loadingScheda = false;
        });
      } else {
        this.loadingScheda = false;
      }
    });
  }

  loadCopertina() {
    this.loadingCopertina = true;
    const request = this.bookservice.imageRequest(
      this.book.isbn.toString()
    );
    fetch(request, { cache: 'reload' }).then((response) => {
      if (response.status !== 404) {
        response.blob().then((blob) => {
          this.immagineCopertina =
            URL.createObjectURL(blob);
          this.setCopertina(blob, false);
          this.loadingCopertina = false;
        });
      } else {
        this.immagineCopertina = null;
        this.loadingCopertina = false;
      }
    });
  }

  downloadPdf() {
    const request = this.bookservice.schedaNovitaRequest(
      this.book.isbn.toString()
    );
    fetch(request, { cache: 'reload' }).then((response) => {
      if (response.status != 404) {
        response.blob().then((blob) => {
          const a = document.createElement('a');
          a.href = URL.createObjectURL(blob);
          a.download = `${this.book.isbn}.pdf`;
          a.click();
        });
      }
    });
  }

  addTag(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    if (this.checkTags(value)) {
      if ((value || '').trim()) {
        this.tags.push(value.trim());
      }
      if (input) {
        input.value = '';
      }
      this.book.tags = this.tags.toString();
    }
  }

  /**
   * Controllo se i tag, con l'aggiunta di quello che sto cercando di inserire, non superano i 100 caratteri
   * @returns
   */
  checkTags(insertValue: string): boolean {
    this.charTag =
      this.tags.toString().length + insertValue.length <=
      100;

    return this.charTag;
  }

  removeTag(tag: any): void {
    const index = this.tags.indexOf(tag);
    if (index >= 0) {
      this.tags.splice(index, 1);
    }
    this.book.tags = '';
    let i = [];
    this.tags.forEach((item) => {
      i.push(item.name);
    });
    this.book.tags = i.toString();
  }

  setAutori($event) {
    this.autoriSelected = $event;
    this.book.cod_autore_1 = 0;
    this.book.cod_autore_2 = 0;
    this.book.cod_autore_3 = 0;
    this.book.cod_autore_4 = 0;
    this.book.cod_autore_5 = 0;
    this.autoriSelected.forEach((element, index) => {
      let autoreIndex = index + 1;
      this.book['cod_autore_' + autoreIndex] = element.cod;
    });
  }

  /**
   * funzione che serve a salvare la copertina a BE
   * @param $event immagine che viene passata dal componente
   * @param saveToBE se l'immagine va salvata a BE, così che nel primo caricamento non si faccia una chiamata inutile
   */
  setCopertina($event, saveToBE = true): void {
    if ($event !== null) {
      this.copertina.delete('image');
      this.copertina.append('image', $event);
    } else {
      this.copertina.delete('image');
    }

    /*  if (saveToBE) {
      this.saveCopertina(this.book.isbn);
    } */

    // this.book.sizeScheda = ($event) ? $event.size : 0;
  }

  setPdf($event, tipo: string, check = true): void {
    if ($event !== null) {
      this.schedaNovita.delete('scheda');
      this.schedaNovita.append('scheda', $event);
      this.pdffilename = $event.name;
      if (check) {
        this.loadingScheda = true;
        const sub = this.bookservice
          .checkSchedaNovita(this.schedaNovita)
          .subscribe({
            next: (data: simpleResponce) => {
              if (data.success) {
                this.pdffilename = data.filename;
              } else {
                this.unvalidPdf();
              }
            },
            error: (er) => {
              this.unvalidPdf();
            },
            complete: () => (this.loadingScheda = false),
          });

        this.subscriptions.push(sub);
      }
    } else {
      this.schedaNovita.delete('scheda');
    }
  }

  /**
   * Unvalid pdf action
   */
  private unvalidPdf() {
    this.toast.error(
      'Il pdf che hai caricato non è valido e sarà scartato.'
    );
    this.pdffilename = '';
    this.schedaNovita.delete('scheda');
    this.loadingScheda = false;
  }

  private checkPartizione(partizione) {
    //prendo la lunghezza della partizione
    const l = partizione.length;
    //verifico che isbn inizi con la partizione fornita;
    if (
      Number(this.book.isbn.toString().substring(0, l)) ===
      Number(partizione)
    ) {
      return true;
    }
    return false;
  }

  submit() {
    if (!this.ristampa && this.action === 'insert') {
      if (
        this.book.isbn?.toString().length === 13 &&
        this.checkIsbn(this.book.isbn)
      ) {
        // controllo l'isbn
        const sub = this.bookservice
          .checkIsbn(this.book.isbn)
          .subscribe((resp: any) => {
            if (resp.success === true) {
              this.inserimento();
            } else {
              this.toast.error(
                `Il codice da te inserito risulta già inserito nei nostri archivi, sei pregato di inserire un ISBN diverso per poter continuare con l'inserimento`,
                'Errore ISBN'
              );
            }
          });

        this.subscriptions.push(sub);
      } else {
        this.toast.error(
          `Il codice ISBN ${this.book.isbn.toString()} non è valido`,
          'Codice ISBN non valido'
        );
      }
    } else {
      this.inserimento();
    }
  }

  inserimento() {
    this.error = false;

    // controllo l'isbn ma solo se si tratta di una novita non per le ristampe.

    if (!this.book.richStampa) {
      this.toast.error(
        `Ti prego, facci sapere le opzioni di stampa`,
        'Informazione necessaria'
      );
      this.errors.richiestastampa = true;
      this.error = true;
    }

    if (Number(this.book.numero_pagine) < 1) {
      this.toast.error(
        `Il numero di pagine deve essere maggiore a 0`,
        'Informazione non valida'
      );
      this.error = true;
    }

    if (this.book.base < 5 || this.book.base > 50) {
      this.toast.error(
        `Il campo base deve avere valori compresi tra 5 e 50`,
        'Informazione non valida'
      );
      this.error = true;
    }

    if (this.book.altezza < 8 || this.book.altezza > 60) {
      this.toast.error(
        `Il campo altezza deve avere valori compresi tra 8 e 60`,
        'Informazione non valida'
      );
      this.error = true;
    }

    if (
      this.book.spessore < 0.3 ||
      this.book.spessore > 20
    ) {
      this.toast.error(
        `Il campo spessore deve avere valori compresi tra 0.3 e 20`,
        'Informazione non valida'
      );
      this.error = true;
    }

    if (this.book.peso < 100 || this.book.peso > 3000) {
      this.toast.error(
        `Il campo peso deve avere valori compresi tra 100 e 3000`,
        'Informazione non valida'
      );
      this.error = true;
    }

    if (
      (this.book &&
        this.book.recensione &&
        this.book.recensione.length < 10) ||
      !this.book.recensione
    ) {
      this.toast.error(
        `L'abstract è un campo obbligatorio`,
        'Informazione necessaria'
      );
      this.error = true;
    }

    if (!this.copertina.has('image')) {
      this.toast.error(
        `Almeno un'immagine deve essere caricata`,
        'Informazione necessaria'
      );
      this.error = true;
    }

    if (!this.schedaNovita.has('scheda')) {
      this.toast.error(
        `Il pdf della scheda novità non è stato fornito`,
        'Informazione necessaria'
      );
      this.error = true;
    }

    // controllo la tabella delle partizioni per il codice EAN */
    let result = false;
    if (this.usr.partizioni) {
      this.usr.partizioni.forEach((partizione) => {
        if (result === false) {
          result = this.checkPartizione(
            partizione.EP_PARTIZIONE
          );
        }
      });
    } else {
      result = true;
    }

    const payload = this.book.getPayLoad();
    payload.filename = this.pdffilename;

    if (!payload.NV_VET_AUT_1) {
      this.toast.info(
        `Se l'autore che cerchi non si trova tra quelli in lista, ne puoi aggiungere uno tramite il pulsante <span class="material-icons">person_add_alt_1</span> `,
        'Non trovi un autore?',
        { enableHtml: true }
      );
      this.toast.error(
        "Per continuare con l'insertimento della novità, aggiungi un autore",
        'Nessun Autore selezionato'
      );
      this.error = true;
    }

    if (this.error) {
      return;
    }

    // Il form resta in stato "loading" per l'intera durata della catena di
    // salvataggio (libro -> copertina -> [immagini aggiuntive]), e non più
    // per un tempo fisso arbitrario: un vecchio polling a setInterval(100ms)
    // chiudeva il form (OnClickNovita.emit) al primo tick in cui
    // loadingCopertina/loadingAdditionalImages risultavano false, cosa che
    // succedeva quasi subito perché quei due flag non vengono più aggiornati
    // dal nuovo flusso a catena. Il form veniva quindi distrutto dal parent
    // (action passa a 'list') mentre le richieste di upload copertina/
    // immagini erano ancora in volo: ngOnDestroy disiscrive tutte le
    // subscription, e Angular annulla le richieste HTTP non ancora
    // completate, perdendo silenziosamente la copertina pur con la novità
    // già salvata. Ora "loading" si spegne solo quando lo stream della
    // catena arriva davvero a completamento (successo o fallimento gestito).
    this.loading = true;
    this.error = false;

    if (this.action === 'insert') {
      // checkIsbn concatenato all'inserimento: viene eseguito immediatamente
      // prima di insertWbook, così invii ravvicinati o più schede aperte non
      // possono più creare due novità con lo stesso ISBN. Il check in submit()
      // e quello del validatore restano come feedback anticipato all'utente.
      // Le ristampe riutilizzano legittimamente un ISBN esistente e sono escluse.
      const guard$ = this.ristampa
        ? of({ success: true } as any)
        : this.bookservice.checkIsbn(this.book.isbn);

      // Il form va chiuso (OnClickNovita.emit) solo se l'inserimento è
      // arrivato in fondo senza errori: sia il rifiuto per ISBN duplicato
      // sia un eventuale fallimento di insertWbook/immagini/copertina
      // fanno completare lo stream tramite EMPTY o handleOperationWithToast
      // (che assorbe l'errore in un toast), quindi "complete" da solo non
      // basta più a significare "salvato con successo".
      let hasFailure = false;
      const markFailure = () => (hasFailure = true);

      const sub = guard$
        .pipe(
          switchMap((resp: any) => {
            if (resp?.success !== true) {
              this.loading = false;
              this.toast.error(
                `Il codice ISBN ${this.book.isbn} risulta già presente in archivio: non è possibile inserire due volte la stessa novità.`,
                'ISBN duplicato'
              );
              return EMPTY;
            }
            return this.eseguiInserimentoWbook(
              payload,
              markFailure
            ).pipe(
              tap({
                complete: () => {
                  this.loading = false;
                  this.submitStepsTotal = 0;
                  if (hasFailure) {
                    this.toast.error(
                      `Controlla i messaggi d'errore sopra: alcune parti dell'inserimento non sono andate a buon fine. Riprova prima di uscire dalla scheda.`,
                      'Inserimento incompleto'
                    );
                    return;
                  }
                  this.OnClickNovita.emit(true);
                },
              })
            );
          })
        )
        .subscribe({
          next: (val) => {
            console.log(val);
          },
          error: (err) => {
            this.loading = false;
            this.submitStepsTotal = 0;
            console.error(err);
          },
        });

      this.subscriptions.push(sub);
    } else {
      // Il salvataggio in modifica elimina le immagini aggiuntive esistenti
      // e le ricarica per intero (nessun endpoint di "replace" lato backend):
      // se il ricaricamento fallisce dopo che l'eliminazione è riuscita, le
      // immagini sono perse. In precedenza l'errore veniva solo mostrato in
      // un toast e il form si chiudeva comunque (complete → emit) come se
      // tutto fosse salvato. Ora "complete" chiude il form solo se nessuna
      // delle tre operazioni è fallita; altrimenti resta aperto con un
      // avviso, così l'utente può accorgersi della perdita e riprovare.
      let hasFailure = false;
      const markFailure = () => (hasFailure = true);

      const modifySubscriptions = merge(
        this.handleOperationWithToast(
          this.bookservice.deleteAdditionalImages(this.book.isbn).pipe(
            catchError(() => of(null)),
            switchMap(() => this.images.length > 0
              ? this.bookservice.insertAdditionalImages(this.additionalImages, this.book.isbn)
              : of(null)
            )
          ),
          this.images.length > 0
            ? 'Salvataggio delle immagini aggiuntive riuscito'
            : 'Eliminazione delle immagini aggiuntive riuscito',
          `Errore nell'inserimento delle immagini aggiuntive`,
          markFailure
        ),
        this.handleOperationWithToast(
          this.bookservice.insertCopertina(
            this.copertina,
            this.book.isbn
          ),
          'Salvataggio della copertina riuscito',
          `Errore nell'inserimento della copertina`,
          markFailure
        ),
        this.handleOperationWithToast(
          this.bookservice.saveBook(payload, this.book.oid),
          'Salvataggio della novità riuscito',
          `Errore nell'inserimento della novità`,
          markFailure
        )
      );

      const sub = modifySubscriptions.subscribe({
        next: () => {},
        error: (err) => {
          this.loading = false;
          console.error(err);
        },
        complete: () => {
          this.loading = false;
          if (hasFailure) {
            this.toast.error(
              `Controlla i messaggi d'errore sopra: alcune modifiche non sono state salvate correttamente. Riprova prima di uscire dalla scheda.`,
              'Salvataggio incompleto'
            );
            return;
          }
          this.OnClickNovita.emit(true);
        },
      });

      this.subscriptions.push(sub);
    }
  }

  /**
   * Costruisce lo stream di inserimento della nuova novità (wbook + immagini
   * aggiuntive + copertina). Estratto da inserimento() per poterlo restituire
   * a valle del check di unicità ISBN, senza sottoscriverlo qui.
   *
   * insertWbook viene eseguita per prima e attesa: immagini aggiuntive e
   * copertina partono solo dopo che il record del libro è stato creato, per
   * evitare che store-copertina (upload più lento) arrivi al backend prima
   * che il libro esista, causando un caricamento copertina fallito in modo
   * intermittente pur con novità salvata correttamente.
   *
   * store-copertina e store-additional-images vengono poi eseguite in
   * sequenza (non più in merge concorrente): entrambe le API modificano lo
   * stato "immagini" dello stesso libro lato BE, ed eseguirle in parallelo
   * poteva causare una race in cui la risposta di store-additional-images
   * sovrascriveva silenziosamente l'esito di store-copertina (la novità
   * risultava salvata con successo ma, riaprendo la scheda, la copertina
   * risultava assente). store-additional-images viene inoltre invocata solo
   * se ci sono davvero immagini aggiuntive da caricare, invece di essere
   * chiamata comunque con un FormData vuoto.
   */
  /**
   * @param onError invocato per qualsiasi fallimento (insertWbook o le
   * chiamate successive): serve al chiamante per capire che lo stream è
   * arrivato a "complete" per un errore e non deve trattarlo come un
   * inserimento riuscito (vedi guard$ in inserimento()).
   */
  private eseguiInserimentoWbook(
    payload: any,
    onError: () => void
  ): Observable<any> {
    const hasAdditionalImages =
      this.additionalImages.has('images[]');

    // stato della barra di avanzamento a step: libro -> copertina -> [immagini aggiuntive]
    this.submitStepsTotal = hasAdditionalImages ? 3 : 2;
    this.submitStepIndex = 0;
    this.submitStepLabel = 'Salvataggio dati libro in corso...';

    return this.bookservice.insertWbook(payload).pipe(
      tap(() => {
        this.toast.success('Salvataggio della novità riuscito');
        this.submitStepIndex = 1;
        this.submitStepLabel = 'Caricamento copertina in corso...';
      }),
      catchError((err) => {
        this.toast.error(`Errore nell'inserimento della novità`);
        onError();
        // il libro non è stato creato: non tentare l'upload di immagini/copertina
        return EMPTY;
      }),
      switchMap(() => {
        const copertina$ = this.handleOperationWithToast(
          this.bookservice.insertCopertina(
            this.copertina,
            this.book.isbn
          ),
          'Copertina inserita con successo',
          `Errore nell'isnerimento della copertina`,
          onError
        ).pipe(
          tap(() => {
            this.submitStepIndex = 2;
            this.submitStepLabel = hasAdditionalImages
              ? 'Caricamento immagini aggiuntive in corso...'
              : 'Salvataggio completato';
          })
        );

        const additionalImages$ = hasAdditionalImages
          ? this.handleOperationWithToast(
              this.bookservice.insertAdditionalImages(
                this.additionalImages,
                this.book.isbn
              ),
              'Salvataggio delle immagini aggiuntive riuscito',
              `Errore nell'inserimento delle immagini aggiuntive`,
              onError
            ).pipe(
              tap(() => {
                this.submitStepIndex = 3;
                this.submitStepLabel = 'Salvataggio completato';
              })
            )
          : EMPTY;

        return concat(copertina$, additionalImages$);
      })
    );
  }

  /**
   *
   * @param operation$ Observable che andrò a sotoscrivere
   * @param successMessage messagio in caso di successo
   * @param errorMessage messaggio in caso di errore
   * @returns
   */
  handleOperationWithToast<T>(
    operation$: Observable<T>,
    successMessage: string,
    errorMessage: string,
    onError?: () => void
  ): Observable<T> {
    return operation$.pipe(
      tap(() => {
        this.toast.success(successMessage);
      }),
      catchError((err) => {
        this.toast.error(errorMessage);
        onError?.();
        return of(null);
      })
    );
  }

  saveCopertina(ean) {
    if (this.copertina.has('image')) {
      this.loadingCopertina = true;
      this.messageservice.setEvent({
        type: 'loadImage',
        event: { ean: this.book.isbn },
      });
      //  this..setEvent({type:'loadImage', event : { ean : this.book.isbn} });
      if (!this.book.oid) {
        const sub = this.bookservice
          .insertCopertina(this.copertina, ean)
          .subscribe(
            (data) => {
              this.toast.info(
                'Immagine copertina inserita con successo'
              );
              this.messageservice.setEvent({
                type: 'reloadImage',
                event: { ean: this.book.isbn },
              });
              this.loadingCopertina = false;
            },
            (error) => {
              this.loadingCopertina = false;
              this.error = true;
              this.toast.error(
                "Si sono verificati degli errori durante il caricamento dell'immagine di copertina"
              );
            }
          );

        this.subscriptions.push(sub);
      }
    }
  }

  /**
   * Carica una collezione (generi, categorie, collane, ...) dalla cache del
   * service worker; se la cache non è ancora popolata o l'entry manca,
   * effettua un fetch di rete diretto invece di lasciare "steps" bloccato
   * per sempre (e con esso l'attesa in loadBook, vedi setInterval sotto).
   */
  private async loadCachedCollection(
    name: string,
    assign: (data: any) => void,
    editore?: string
  ) {
    const request = this.bookservice.getCollectionCached(
      name,
      editore
    );
    try {
      let response: Response;
      try {
        const cache = await caches.open(environment.cache);
        response = await cache.match(request);
      } catch {
        response = undefined;
      }
      if (!response) {
        response = await fetch(request);
      }
      assign(await response.json());
    } catch (err) {
      // anche in caso di errore di rete sul fallback, non si deve bloccare
      // "steps" per sempre (vedi stepsInterval in loadBook): si prosegue
      // senza dato, l'utente vedrà la relativa tendina vuota invece che
      // un loop infinito che non arriva mai a mostrare l'IVA.
      console.error(
        `Impossibile caricare la collezione "${name}"`,
        err
      );
    } finally {
      this.steps++;
    }
  }

  async getCollaneAdmin(editore) {
    await this.loadCachedCollection(
      'collane',
      (data) => (this.collane = data),
      editore
    );
  }

  async getCollane() {
    await this.loadCachedCollection(
      'collane',
      (data) => (this.collane = data)
    );
  }

  async getGeneri() {
    await this.loadCachedCollection(
      'generi',
      (data) => (this.generi = data)
    );
  }

  async getCategorie() {
    await this.loadCachedCollection(
      'categorie',
      (data) => (this.categorie = data)
    );
  }

  async getArgomenti() {
    await this.loadCachedCollection(
      'argomenti',
      (data) => (this.argomenti = data)
    );
  }

  async getRilegature() {
    await this.loadCachedCollection(
      'rilegature',
      (data) => (this.rilegature = data)
    );
  }

  async getLingue() {
    await this.loadCachedCollection(
      'lingue',
      (data) => (this.lingue = data)
    );
  }

  getTabellaIva(toast = true) {
    const sub = this.bookservice
      .getTabellaIva()
      .subscribe((iva: Array<description>) => {
        //this.iva = iva;
        const i = _.findIndex(this.tabellaIva, [
          'cod',
          this.book.cod_categoria,
        ]);
        const row = this.tabellaIva[i];

        if (!row) {
          console.error(
            `Nessuna aliquota IVA mappata per la categoria ${this.book.cod_categoria}`
          );
          return;
        }

        iva.forEach((item) => {
          if (parseInt(item.cod) === row.iva) {
            this.aliquotaIva = item;
            this.book.cod_iva = parseInt(item.cod);
            if (toast) {
              this.toast.info(
                item.descrizione,
                'Aliquota IVA'
              );
            }
          }
        });
      });

    this.subscriptions.push(sub);
  }

  clickClose() {
    if (this.viewOnly!==true) {
    let dialogRef = this.dialog.open(
      GenericDialogComponent,
      {
        width: '400px',
        data: {
          title: 'Attenzione',
          content: `
          Abbandonando ora il form senza salvare perderai tutte le informazioni inserite`,
        },
      }
    );

    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.OnClickNovita.emit(true);
      }
    });
    } else {
     this.OnClickNovita.emit(true);
    }
  }
  setCollaboratori(event) {
    // controllo se ci sono elementi eliminati
    this.book.collaboratori = event;
  }

  aggiungiAutore(type: string) {
    const dialogRef = this.dialog.open(
      NuovoAutoreComponent,
      {
        data: { nome: '', cognome: '', tipo: type },
        height: 'auto',
        width: 'auto',
      }
    );

    let inserted = false;

    dialogRef
      .afterClosed()
      .toPromise()
      .then((data) => {
        if (data) {
          if (
            data &&
            data.nome &&
            data.cognome &&
            !inserted
          ) {
            const sub = this.bookservice
              .insertAutore(data)
              .subscribe((resp: any) => {
                if (resp.inserted) {
                  this.toast.success(
                    `${
                      type === 'autore'
                        ? `L'autore`
                        : 'Il collaboratore'
                    } ${data.nome} ${
                      data.cognome
                    } è stato inserito correttamente`,
                    'Inserimento Autore'
                  );
                } else {
                  this.toast.info(
                    `  ${
                      type === 'autore'
                        ? `L'autore`
                        : 'Il collaboratore'
                    } ${data.nome} ${
                      data.cognome
                    } è già presente in archivio, lo inserisco nella sezione apposita`
                  );
                }

                if (type === 'autore') {
                  this.autoriSelected.push({
                    cod: resp.cod,
                    descrizione: `${this.primaLetterMaiuscola(
                      data.cognome
                    )} ${this.primaLetterMaiuscola(
                      data.nome
                    )}`,
                  });
                  this.setAutori(this.autoriSelected);
                } else {
                  this.collaboratoriSelected.push({
                    cod: resp.cod,
                    descrizione: `${data.cognome} ${data.nome}`,
                    type: 'curatore',
                  });

                  this.setCollaboratori(
                    this.collaboratoriSelected
                  );
                }
              });

            this.subscriptions.push(sub);
          } else {
            this.toast.info(
              `Attenzione, ${type} già presente in archivio`
            );
          }
        }
      });
  }

  primaLetterMaiuscola(str: string): string {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  richiestaStampa(event) {
    this.book.richStampa = event.value;
    this.errors.richiestastampa = false;
  }

  saveAdditionalImages(id) {
    if (this.additionalImages.has('images[]')) {
      this.loadingAdditionalImages = true;
      const sub = this.bookservice
        .insertAdditionalImages(this.additionalImages, id)
        .subscribe(
          (data) => {
            this.loadingAdditionalImages = false;
            this.toast.info(
              'Immagini inserite con successo'
            );
          },
          (error) => {
            this.loadingAdditionalImages = false;
            this.toast.error(
              'Si sono verificati degli errori durante il caricamento delle immagini'
            );
            this.error = true;
          }
        );
      this.subscriptions.push(sub);
    }
  }

  deleteAdditionalImages(id) {
    this.loadingAdditionalImages = true;
    const sub = this.bookservice
      .deleteAdditionalImages(id)
      .subscribe(
        (data) => {
          /* this.status--; */
          this.loadingAdditionalImages = false;
        },
        (error) => {
          this.loadingAdditionalImages = false;
          this.error = true;
        }
      );

    this.subscriptions.push(sub);
  }

  /**
   * salvo le immagini aggiuntive
   * @param $event immagine aggiunta
   */
  setAdditionalImages($event): void {
    // Eliminazione o aggiunta immagine
    if ($event === 0) {
      this.images.pop();
      if (this.images.length === 0) {
        this.additionalImages.delete('images[]');
        this.additionalImages.delete('imageTypes[]');
      }
    } else {
      this.images.push($event);
    }

    this.additionalImages.delete('images[]');
    this.additionalImages.delete('imageTypes[]');

    for (let item of this.images) {
      this.additionalImages.append('images[]', item.file);
      this.additionalImages.append('imageTypes[]', item.imageType.code);
    }
  }

  /**
   * Setto le immagini aggiuntive
   * @param $event immagine da aggiungere
   */
  setImages($event) {
    if ($event === 0) {
      this.images.pop();
      if (this.images.length === 0) {
        this.additionalImages.delete('images[]');
        this.additionalImages.delete('imageTypes[]');
      }
    } else {
      this.images.push($event);
    }

    this.additionalImages.delete('images[]');
    this.additionalImages.delete('imageTypes[]');
    for (let item of this.images) {
      this.additionalImages.append('images[]', item.file);
      this.additionalImages.append('imageTypes[]', item.imageType.code);
    }
  }

  getPartizioni() {
    const sub = this.bookservice
      .partizioni(this.book.editore)
      .subscribe((partizioni: Array<Partizioni>) => {
        partizioni.forEach((partizione) => {
          this.isbnOptions.push(partizione.EP_PARTIZIONE);
        });
      });

    this.subscriptions.push(sub);
  }

  /**controllo se l'isbn inserito e' valido */
  checkIsbn(isbn) {
    if (isbn?.length > 0) {
      const tokens = isbn.split('');
      let sum = 0;
      tokens.forEach((item, index) => {
        let multi = index % 2 ? 3 : 1;
        sum += Number(item) * multi;
      });
      return sum % 10 === 0 ? true : false;
    }
    return false;
  }

  /**
   * Validatore asincrono del campo ISBN: checksum, appartenenza alla
   * partizione dell'editore e unicità in archivio.
   *
   * Come AsyncValidatorFn (invece del precedente ValidatorFn sincrono con
   * subscribe interna), Angular annulla automaticamente la richiesta HTTP
   * precedente ogni volta che il valore cambia di nuovo prima che sia
   * arrivata una risposta: niente più risposte fuori ordine che
   * invalidavano il campo in ritardo (causa della sparizione del widget
   * copertina, gestito con *ngIf="isbnControl.valid" nel template) e
   * niente più subscription accumulate in `subscriptions[]`.
   */
  isbnAsyncValidator(): AsyncValidatorFn {
    return (
      control: AbstractControl
    ): Observable<ValidationErrors | null> => {
      if (!this.checkIsbn(control.value)) {
        return of(
          control.value?.length == 13
            ? { invalidIsbn: 'Isbn non valido' }
            : null
        );
      }

      if (
        this.usr.profile !== 'admin' &&
        this.isbnOptions.filter((isbn) =>
          control.value.includes(isbn)
        ).length <= 0
      ) {
        return of({
          invalidIsbn: `Radice non presente, contattare CDA per l'inserimento`,
        });
      }

      return of(control.value).pipe(
        // debounceTime non avrebbe alcun effetto qui: la sorgente è un
        // singolo valore che emette e completa nello stesso tick, e
        // debounceTime scarica subito il valore bufferizzato al completamento
        // della sorgente invece di attendere il timer. delay() ritarda
        // davvero la richiesta HTTP: se l'utente digita un'altra cifra prima
        // che scada, Angular annulla questa validazione (vedi commento sopra
        // su isbnAsyncValidator) e ne parte una nuova, ottenendo comunque
        // l'effetto di debounce voluto.
        delay(300),
        switchMap((isbn) => this.bookservice.checkIsbn(isbn)),
        map((resp: any) => {
          if (this.ristampa && resp.item) {
            const curatoriObj = {
              CUR: 'curatore',
              ILL: 'illustratore',
              TRA: 'traduttore',
              PRE: 'prefazione',
            };

            this.collaboratoriSelected = this.collaboratoriSelected.map(
              (el, index) => ({
                ...el,
                type: curatoriObj[
                  resp.item[`NV_VET_RUO_${index + 1}`] ??
                    'CUR'
                ],
              })
            );
            this.book.collaboratori = this.collaboratoriSelected;
          }

          if (
            !resp.success &&
            this.action !== 'edit' &&
            !this.ristampa
          ) {
            return { invalidIsbn: 'Isbn già inserito' };
          }
          return null;
        }),
        catchError(() => of(null))
      );
    };
  }

  /**
   * Mi aggiorno la data in cui il prodotto deve essere consegnato in magazzino
   * @param event data inserita in data commercializzazione
   */
  updateDate(event) {
    this.book.datapubblicazione = event;

    this.dataConsegnaMagazzino = moment(event)
      .subtract('14', 'days')
      .format('DD/MM/YYYY');
  }

  /**
   * Quando non c'è l'isbn per l'immaggine faccio vedere questo dialog
   */
  showNoIsbnDialog() {
    const dialog = this.dialog.open(
      GenericDialogComponent,
      {
        width: '250px',
        data: {
          title: 'Attenzione',
          content:
            'non si può inserire una copertina senza immettere un ISBN valido',
        },
      }
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((el) => {
      if (el) {
        el.unsubscribe();
      }
    });
    window.removeEventListener(
      'beforeunload',
      this.beforeUnloadHandler
    );
    if (this.stepsInterval) {
      clearInterval(this.stepsInterval);
      this.stepsInterval = null;
    }
  }
}
